import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getDemos, createBulkDemos, sendMeetingInvite, deleteDemo, updateDemo } from '../lib/demoApi';

export const useGetDemos = (page = 1, limit = 10, filters = {}) => {
  const userStr = localStorage.getItem("user");
  let employeeId;
  let hostBy;

  if (userStr) {
    const user = JSON.parse(userStr);
    if (user.role === "employee") {
      employeeId = user?.id;
      hostBy = user?.id;
    }
  }

  return useQuery({
    queryKey: [
      "demos",
      page,
      limit,
      employeeId,
      hostBy,
      filters.search,
      filters.status,
      filters.startDate,
      filters.endDate,
    ],
    queryFn: () =>
      getDemos(
        page,
        limit,
        employeeId,
        hostBy,
        filters.search,
        filters.status,
        filters.startDate,
        filters.endDate
      ),
    keepPreviousData: true,
  });
};



export const useCreateBulkDemos = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBulkDemos,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['demos'] });
    },
  });
};

export const useUpdateDemo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateDemo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['demos'] });
    },
  });
};

export const useSendMeetingInvite = () => {
  return useMutation({
    mutationFn: sendMeetingInvite,
  });
};

export const useDeleteDemos = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteDemo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['demos'] });
    },
  });
};
